import { render, staticRenderFns } from "./Retailers.vue?vue&type=template&id=6949f10c&scoped=true&"
import script from "./Retailers.vue?vue&type=script&lang=js&"
export * from "./Retailers.vue?vue&type=script&lang=js&"
import style0 from "./Retailers.vue?vue&type=style&index=0&id=6949f10c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949f10c",
  null
  
)

export default component.exports